export default {
  files: [
    {
      id: 'news',
      name: 'news file',
      columns: ['id', 'type', 'definition', 'function']
    }
  ]
}
